module.exports = __webpack_public_path__ + "static/img/light-shed.f8ed7b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/light-shed.png
// module id = 666
// module chunks = 64